export function parseDottedOrderDate(dateString: string) {
  const year = parseInt(dateString.substring(0, 4));
  const month = parseInt(dateString.substring(4, 6)) - 1; // Month is 0-indexed in JS
  const day = parseInt(dateString.substring(6, 8));
  const hours = parseInt(dateString.substring(9, 11));
  const minutes = parseInt(dateString.substring(11, 13));
  const seconds = parseInt(dateString.substring(13, 15));

  const date = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
  return date;
}

export function getRootStartDate(dottedOrder: string) {
  return parseDottedOrderDate(dottedOrder.split('.')[0].split('Z')[0]);
}
